import React from 'react';
import { Empty, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import { Util } from 'codeArt/common';
import ModuleSide from 'codeArt/components/ModuleSide';
import { Shifts, Teams, Devices } from 'app/constant';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import AirplayIcon from '@material-ui/icons/Airplay';



let _data = {};

DataProvider.register = (name, data) => {
  _data[name] = data;
}

function DataProvider() {

  let _cache = {}; //上次访问的数据索引的缓存
  let _history = {}; //历史

  function getDataIndex(name) {
    return _cache[name] || 0;
  }

  function saveDataIndex(name, index) {
    _cache[name] = index;
  }

  function getData(name, ctx) {
    let data = _data[name] || [];
    if (Util.type(data) === "function") return data(ctx);
    return data;
  }

  this.history = (name) => {
    return _history[name];
  }

  this.get = (name, ctx) => {
    let items = getData(name, ctx);

    if(!items || items.length==0) return;
    if (items.length === 1) return items[0]; //只有一个数据项，表示指定该数据呈现

    let prevIndex = getDataIndex(name);
    let currentIndex = prevIndex;

    while (true) {
      currentIndex = getCycleIndex(currentIndex, items.length - 1);
      if (currentIndex !== prevIndex) break;
    }

    saveDataIndex(name, currentIndex);
    let item = items[currentIndex];  //数据提供器内部的数据不同，返回克隆，这样外界随便改，不会影响数据提供器的数据

    _history[name] = item; //记录历史
    return item;
  }

  function getCycleIndex(pointer, max) {
    if (Util.invalid(pointer) || pointer >= max) return 0;
    return pointer + 1;
  }
}


export const DataContext = {};

DataContext.register = (items) => {  //注册一组数据项
  items.forEach(({ name, data }) => {
    DataProvider.register(name, data);
  });
}

const _dataProvider = new DataProvider();

DataContext.get = (name,param={}) => {
  let {arg} = param;
  return _dataProvider.get(name, { arg,dp:_dataProvider });
}